module.exports = __webpack_public_path__ + "static/our-mission2-0e382241b128135ceadfc0e797ee96ef.png";